import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { navigate } from 'gatsby';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import RichText from '../../UI/RichText';
import SelectedCarrier from '../../elements/SelectedCarrier/SelectedCarrier';
import SelectedTradeIn from '../../elements/SelectedTradeIn/SelectedTradeIn';
import { updateShowAddToCartTooltip } from '../../../redux/reducers/cartReducer';
import { ISelectedCarrier } from '../../ReservePhoneBlade/types';
import {
  BladeSubtitle,
  BladeTitle,
  PhoneTitle,
  SectionWrapper,
  Wrapper,
  LegalText,
  CarrierWrapper,
  ActionsWrapper,
  Button,
  GridWrapper,
  ButtonText,
  CarrierLabel,
} from './styles';

interface Props {
  phone: Record<string, any>;
  selectedStorageSize: string;
  selectedColour: string;
  selectedCarrier?: ISelectedCarrier;
  variantLabels: Record<string, any>;
  closeBlade: () => void;
  cmsData: Record<string, any>;
  showDisclaimer: boolean;
}

const legalOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <LegalText>{children}</LegalText>,
  },
};

const CartSuccessPhase = ({
  phone,
  selectedStorageSize,
  selectedColour,
  selectedCarrier,
  variantLabels,
  closeBlade,
  cmsData,
  showDisclaimer = true,
}: Props) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  // TODO Replace with field name
  const legalText = cmsData.combinatorSectionItems.find(
    ({ contentful_id }) => contentful_id === '3POjMxlZ0q3F1J3DXtwAYG',
  );

  const labelSection = cmsData.combinatorSectionItems.find(
    ({ contentful_id }) => contentful_id === '6LvivNkZpObvXp2B7G7xQi',
  );

  const labels = labelSection.formFields.reduce((obj, item) => ({
    ...obj,
    [item.fieldName]: item,
  }), {});

  const goToCart = () => {
    dispatch(updateShowAddToCartTooltip(true));
    navigate(`/${intl.locale}/cart`);
  };
  const phoneTitle = `${phone.displayName} ${selectedStorageSize} ${selectedColour}`;
  return (
    <Wrapper>
      <BladeTitle>{labels['Success Blade Heading'].displayLabel}</BladeTitle>
      <SectionWrapper>
        <BladeSubtitle>
          {labels['Phone Details Label'].displayLabel}
        </BladeSubtitle>
        <PhoneTitle>
          {phoneTitle}
        </PhoneTitle>
        <hr />
        <SelectedTradeIn label={labels['Trade In Label']?.displayLabel} />
        <CarrierWrapper>
          <CarrierLabel>{labels['Carrier Label']?.displayLabel}</CarrierLabel>
          {selectedCarrier && (
            <SelectedCarrier
              carrier={selectedCarrier}
              variantLabels={variantLabels}
            />
          )}
        </CarrierWrapper>
        {showDisclaimer && legalText?.contentBody && (
          <div>
            <RichText
              document={legalText?.contentBody}
              options={legalOptions}
            />
          </div>
        )}
        <hr />
        <ActionsWrapper>
          <Button
            isPrimary={false}
            type="button"
            onClick={closeBlade}
            data-ga="cta-keep browsing-phones"
          >
            <GridWrapper>
              <ButtonText>
                {labels['Keep Shopping Button'].displayLabel}
              </ButtonText>
            </GridWrapper>
          </Button>
          <Button
            isPrimary
            type="button"
            onClick={goToCart}
            data-ga="cta-go to basket-phones"
          >
            <GridWrapper>
              <ButtonText>
                {labels['Go to Basket Button'].displayLabel}
              </ButtonText>
            </GridWrapper>
          </Button>
        </ActionsWrapper>
      </SectionWrapper>
    </Wrapper>
  );
};

export default CartSuccessPhase;
